/**
@ngdoc directive
@name synchroInclude

@description
Synchrounous ng-include

@param {number=} concurrent number of concurrent ajax calls (1 by default)
@param {string} group you need to group elements: setting group="elementsGroup" and concurrent="3" means there will be 3 concurrent ajax calls within "elementsGroup" group
@param {boolean=} enable-cache you may also enable-cache="true" WARNING! please make sure you know what you're doing to not get into troubles with that!
*/

(function() {
    'use strict';


var concurrentLoad = {}; // for grouping loaded elements (holds the number of ajax calls being executed)

var synchroInclude = function($compile, timestampUrl) {
    return {
        restrict: 'EA',
        replace: true,
        scope: true,
        bindToController: {
            src: '=synchroInclude',
            concurrent: '@',
            group: '@',
            loaded: "=?",
            loadingText: "@",
            enableCache: "@"
        },
        controllerAs: 'ctrl',
        controller: ['$scope', '$element', '$attrs', function($scope, $element, $attrs){

            $element.parent().attr('data-angular-compile','');
            var _this = this;
            var MAX;

            this.$onInit = function(){
                (function init(){
                    if(!angular.isDefined(_this.group)) {
                       throw "SynchroInclude: Undefined group attribute!";
                    }
                    if(!angular.isDefined(_this.concurrent)) {
                        _this.concurrent = 1;
                        console.warn("SynchroInclude: Undefined concurrent. The number of concurrent ajax calls set to 1.");
                    }
                    MAX = _this.concurrent;
                    _this.loadingText = _this.loadingText || "Loading...";
                    _this.loaded = false;
                })();


                //console.log('synchronous include! ' + _this.group + ' : ' + concurrentLoad[_this.group]);


                if( !angular.isDefined(concurrentLoad[_this.group]) ){
                    // console.log('undefined!');
                    concurrentLoad[_this.group] = 0;
                }


                //console.log("initialized: "+ concurrentLoad[_this.group]);

                synchroLoad();
            };


            var synchroLoad = function(){
                if(concurrentLoad[_this.group] < MAX){
                    concurrentLoad[_this.group]++;
                    $scope.src = _this.enableCache=='true' ? _this.src : timestampUrl.add(_this.src); // timestamp prevents browser caching
                    // console.log('init loading...: ' + _this.group + ' : ' + concurrentLoad[_this.group]);
                    // console.log($scope.src);
                } else {
                    // wait for the previous to load
                    var watch = $scope.$watch(
                        function($scope){
                            return concurrentLoad[_this.group];
                        }, function(newVal, oldVal){
                            //console.log('newVal '+_this.group+': '+ newVal);
                            if(newVal < MAX){
                                concurrentLoad[_this.group]++;
                                $scope.src = _this.enableCache=='true' ? _this.src : timestampUrl.add(_this.src); // timestamp prevents browser caching
                                // console.log('delayed loading...: ' + _this.group + ' : ' + concurrentLoad[_this.group]);
                                // console.log($scope.src);
                                watch(); // destroy watch as we load only once
                            }
                        }
                    );
                }
            }


            $scope.$watch(
                function(){
                    return _this.src;
                },
                function(newVal, oldVal){
                    if(newVal!=oldVal){
                        _this.loaded = false;
                        synchroLoad();
                    }
                }
            );

            this.onLoad = function(){
                concurrentLoad[_this.group]--;
                _this.loaded = true;
                // console.log("synchroInclude loading finished: " + _this.group + ' : ' + concurrentLoad[_this.group]);
            }

            this.isLoaded = function(){
                return _this.loaded;
            }

            /*$scope.onLoad = function(){
                _this.onLoad();
            }*/
        }],
        transclude: false,
        template: '<div ng-include="src" onload="ctrl.onLoad()" ng-hide="!ctrl.loaded"></div>',
        link: function(scope, element, attrs){
            // add loading spinner
            element.after( $compile([
                '<div class="synchro-include-loading-box" ng-if="!ctrl.loaded">',
                    '<i class="loading-spinner">{{ctrl.loadingText}}</i>',
                '</div>'].join(""))(scope)
            );
        }
    };
}
synchroInclude.$inject = ['$compile', 'timestampUrl'];
angular.module('app').directive('synchroInclude', synchroInclude);



// get activity title from loaded data-objecttitle and place it in the right place
// temporary solution utilizing jQuery
// (please mind the following code is NOT a good practice!)
var amendActivityTileTitle = function() {
    return {
        restrict: 'A',
        scope: false,
        require: 'synchroInclude',
        link: function(scope, element, attrs, synchroIncludeCtrl) {

            var watch = scope.$watch(
                // watching for the tile loaded
                function(synchroIncludeCtrl){
                    return synchroIncludeCtrl.ctrl.loaded;
                },
                function(newVal, oldVal){
                    if(newVal == true){
                        $("[data-objecttitle]").each(function(){
                            var title         = $(this).attr('data-objecttitle');
                            var $titleWrapper = $(this).closest('li').find('.title-wrapper')
                            var $header       = $titleWrapper.find('h2');
                            // might be replaced with <span class="label label-default">
                            title = title.replace("<","&lt;").replace(">","&gt;");
                            if($header[0].innerHTML.trim() != ''){
                                $titleWrapper.before('<span class="label label-default">'+$header[0].innerHTML.trim() + '</span>');
                            }
                            $header[0].innerHTML = title;
                            $(this).removeAttr('data-objecttitle');
                        });
                        watch(); // once done destroy watch
                    }
                }, true
            );

        }
    }
}
angular.module('app').directive('amendActivityTileTitle', amendActivityTileTitle);


// solution utilizing jQuery
// replace the title with full tile
// (please mind the following code is NOT a good practice!)
var removeTimesheetSolrTitle = function() {
    return {
        restrict: 'A',
        scope: false,
        require: 'synchroInclude',
        link: function(scope, element, attrs, synchroIncludeCtrl) {

            var watch = scope.$watch(
                // watching for the tile loaded
                function(synchroIncludeCtrl){
                    return synchroIncludeCtrl.ctrl.loaded;
                },
                function(newVal, oldVal){
                    if(newVal == true){
                        element.parent().find('.timesheet-solr-title').remove();
                        watch(); // once done destroy watch
                    }
                }, true
            );

        }
    }
}
angular.module('app').directive('removeTimesheetSolrTitle', removeTimesheetSolrTitle);

}());
